/**
 * Hero Component
 * 
 * Animated banner section asking how much credit the user needs.
 */

import '../styles/Hero.css'

function Hero() {
  return (
    <section className="hero" role="region" aria-labelledby="hero-title">
      <div className="container">
        <div className="hero-content">
          <h2 id="hero-title" className="hero-title animate-text">
            <span className="text-wrapper">
              Wie viel Kredit benötigen Sie?
            </span>
          </h2>
          <p className="hero-subtitle">
            <i className="fas fa-bolt" aria-hidden="true"></i>
            Sofortige Genehmigung - Schnelle Bearbeitung - Keine versteckten Kosten
          </p>
          <div className="hero-arrow" aria-hidden="true">
            <i className="fas fa-chevron-down"></i>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero
